import { create } from "zustand";
import { AlertStatusType, IAlertState } from "../interface/alert-state.interface";
import { initAlertState } from "../data/initialize/alert-states.data";
import { BootstrapColorType } from "../types/bootstrap.type";


interface IAddPermitRequestPageStore {
    alertState: IAlertState;
    setAlertStateLoading: () => void;
    setAlertState: (status?: AlertStatusType, msg?: string, color?: BootstrapColorType | '') => void;
}

export const useAddPermitRequestPageStore = create<IAddPermitRequestPageStore>()((set) => ({
    alertState: initAlertState,
    setAlertStateLoading: () => set((state) => ({
        ...state,
        alertState: {
            alertStatus: 'loading',
            message: '',
            alertColor: '',
        },
    })),
    setAlertState: (alertStatus: AlertStatusType,
        message: string = '', alertColor: BootstrapColorType | '' = '') => set((state) => {

            if (alertStatus === 'loading' || alertStatus === 'noAlert') {
                message = '';
                alertColor = '';
            }

            if (alertStatus === 'hasAlert' && message === '') {
                alertStatus = 'noAlert';
            }

            if (alertStatus === 'hasAlert' && alertColor === '') {

                alertColor = 'danger';
            }

            return {
                ...state,
                alertState: {
                    alertColor,
                    message,
                    alertStatus,
                }
            }
        }),
}));

export const useGetAPRPAlertState = () => useAddPermitRequestPageStore((state) => state.alertState);
export const useSetAPRPAlertLoading = () => useAddPermitRequestPageStore((state) => state.setAlertStateLoading);
export const useSetAPRPAlertState = () => useAddPermitRequestPageStore((state) => state.setAlertState);